export const stocks = (state) => state.stocks;
export const getStocksRes = (state) => state.getStocks;
export const getNextStocksRes = (state) => state.getNextStocks;
